import { createActions } from 'redux-actions';

const actionCreators = createActions({
  API: {
    REQUEST_ERROR: error => error,
  },
});

export default actionCreators.api;
